<template>
    <span>
        {{ value | cents }}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ]
}
</script>
